export interface Suggestion {
  product: string;
  category: number;
  organisation: string;
}

export class ProductSuggestionResponse {
  public reason: string;
  public suggestions: Suggestion[];

  constructor(reason: string, suggestions: Suggestion[]) {
    this.reason = reason;
    this.suggestions = suggestions;
  }
}

// One product can be offered by several organisations.
export function isSameProduct(a: Suggestion, b: Suggestion): boolean {
  return a.product === b.product && a.organisation === b.organisation;
}
